import { render } from "./Settings.vue?vue&type=template&id=c0e166e6&bindings={\"errors\":\"data\",\"isLoading\":\"data\",\"isUpdating\":\"data\",\"obj\":\"data\",\"fetchData\":\"options\",\"update\":\"options\"}"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
script.render = render

export default script